import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { leaseTransactionJudgeConfig } from './LeaseTransactionJudge.name';

/** リース取引判定のENUM */
enum LeaseTransactionJudge {
  /** 使用権リース */
  useRightsLease = '1',
  /** 少額資産リース */
  smallSumAssetLease = '2',
  /** 短期リース */
  shortLease = '3',
}

const leaseTransactionJudgeMap = new Map([
  ['1', LeaseTransactionJudge.useRightsLease],
  ['2', LeaseTransactionJudge.smallSumAssetLease],
  ['3', LeaseTransactionJudge.shortLease],
]);

const rawValueToLeaseTransactionJudge = rawValueToEnumWithDefault(leaseTransactionJudgeMap, '');

const leaseTransactionJudgeToDisplay = enumToNameWithDefault(
  LeaseTransactionJudge,
  leaseTransactionJudgeConfig,
);

const leaseTransactionJudgeToDisplayWithPrefix = enumToNameWithDefault(
  LeaseTransactionJudge,
  leaseTransactionJudgeConfig,
  true,
);

export {
  LeaseTransactionJudge,
  leaseTransactionJudgeToDisplay,
  leaseTransactionJudgeToDisplayWithPrefix,
  rawValueToLeaseTransactionJudge,
};
